import { useMutation, useQueryClient } from 'react-query'
import { trackedChangeCommentsKeys } from './trackedChangeCommentsKeys'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { TrackedChangeComment } from 'types'
import { buildErrorMessage } from 'utils'
import { trackedChangesKeys } from '../trackedChanges/trackedChangesKeys'

interface Props {
  articleKey: string
  layerId: string
  comment: TrackedChangeComment
}

interface ResponseData {
  comment: TrackedChangeComment
}

export const useToggleTrackedChangeCommentReaction = ({ articleKey, layerId, comment }: Props) => {
  const queryClient = useQueryClient()

  return useMutation<ResponseData, Error, string>(
    trackedChangeCommentsKeys.toggleReaction(comment.tracked_change_id, comment.id),
    async (reaction) => {
      const response = await sendToApi<ResponseData>(
        `/articles/${articleKey}/layers/${layerId}/changes/${comment.tracked_change_id}/comments/${comment.id}/toggle_reaction`,
        {
          method: 'POST',
          body: { reaction },
        },
      )

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return response.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(trackedChangesKeys.list(layerId, {}))
      },
    },
  )
}
